import React, { Component } from "react";
import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import StringUtil from "../../../actions/string";
import DataUtil from "../../../actions/data";

import CadastroEndereco from "./CadastroEndereco";
import CadastroObservacao from "./CadastroObservacao";

class CadastroPaciente extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    if (this.props.match.params.id) {
      this.state.id = this.props.match.params.id;
    }

    this.getInitialState = this.getInitialState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeEndereco = this.handleChangeEndereco.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      nome: "",
      sexo: "M",
      idCismepar: "",
      cpf: "",
      rg: "",
      cns: "",
      email: "",
      dataNascimento: "",
      telefoneCelular: "",
      telefoneResidencial: "",
      telefoneComercial: "",
      nomePai: "",
      nomeMae: "",
      estadoCivil: 0,
      classificacao: 0,
      inativo: false,
      tipoInativacao: 1,
      endereco: {
        id: 0,
        estado: "PR",
        cidade: "LONDRINA",
        logradouro: "",
        numero: "",
        cep: "",
        bairro: "",
        complemento: "",
        pontoReferencia: "",
      },
      observacoes: "",
    };
  }

  // Hack para atualizar a pagina quando estiver nessa rota
  componentWillReceiveProps() {
    window.scrollTo(0, 0);
    this.setState(this.getInitialState());
  }

  componentDidMount() {
    UI.inputHelpers();

    let id = parseInt(this.state.id);
    if (id !== 0) {
      UI.loader("show", "Um momento...");
      API.get("/pacientes/" + this.state.id)
        .then(
          function (json) {
            UI.loader("hide");
            if (!DataUtil.validarData(json.data.dataNascimento)) {
              json.data.dataNascimento = "";
            }
            json.tipoInativacao = json.tipoInativacao ? 1 : json.tipoInativacao;
            this.setState(json.data);
          }.bind(this)
        )
        .catch(function (json) {
          UI.loader("hide");
          UI.alert(json.success, json.message);
        });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeEndereco(event) {
    let endereco = this.state.endereco;
    endereco[event.target.name] = event.target.value;
    this.setState({ endereco: endereco });
  }

  handleChecked(event) {
    this.setState({ [event.target.name]: event.target.checked });
  }

  handleSubmit(event) {
    event.preventDefault();

    // Validação dos campos (exemplo)
    let data = this.state;
    if (data.nome < 3) {
      UI.alert(false, "Nome é obrigatório e precisa ter no mínimo 3 digitos.");
      return;
    }
    if (!DataUtil.validarData(data.dataNascimento)) {
      data.dataNascimento = "";
    }
    if (data.idCismepar.length < 1) {
      UI.alert(false, "É necessário informador o ID Cismepar do paciente.");
      return;
    }

    // Remover formatação
    data.cpf = StringUtil.unmask(data.cpf);

    // Chamada da API
    UI.loader("show", "Um momento...");
    API.post("/pacientes", data)
      .then(
        function (json) {
          if (json.success) {
            if (!DataUtil.validarData(json.data.dataNascimento)) {
              json.data.dataNascimento = "";
            }
            this.setState(json.data);
          }
          UI.alert(json.success, json.message);
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(json.success, json.message);
        UI.loader("hide");
      });
  }

  render() {
    var styleInativo = {
      background: "#eee",
      border: "1px solid #d00",
    };

    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div
              style={this.state.inativo ? styleInativo : null}
              className="card"
            >
              <div className="card-body">
                <div className="form-group row">
                  <div className="col-md-6">
                    {this.state.id === 0 && (
                      <h4 className="card-title">NOVO PACIENTE</h4>
                    )}
                    {this.state.id !== 0 && (
                      <h4 className="card-title">
                        CADASTRO PACIENTE #{this.state.id}
                      </h4>
                    )}
                  </div>
                  {this.state.criadorNome && (
                    <div className="col-md-6 text-right light-description">
                      <span>
                        {this.state.criadorNome} criou em{" "}
                        {this.state.dataCriacao}
                      </span>
                      <br></br>
                      <span>
                        {this.state.editorNome} editou em{" "}
                        {this.state.dataEdicao}
                      </span>
                    </div>
                  )}
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Nome Completo *</label>
                    <input
                      placeholder="NOME COMPLETO"
                      autoFocus
                      name="nome"
                      type="text"
                      className="form-control"
                      value={this.state.nome}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Sexo</label>
                    <select
                      name="sexo"
                      className="form-control"
                      value={this.state.sexo}
                      onChange={this.handleChange}
                    >
                      <option value="M">MASCULINO</option>
                      <option value="F">FEMININO</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>ID Cismepar *</label>
                    <input
                      placeholder="ID CISMEPAR"
                      name="idCismepar"
                      className="form-control"
                      value={this.state.idCismepar}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>CPF</label>
                    <InputMask
                      placeholder="CPF"
                      name="cpf"
                      className="form-control"
                      mask="999.999.999-99"
                      value={this.state.cpf}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>RG</label>
                    <InputMask
                      placeholder="RG"
                      name="rg"
                      className="form-control"
                      mask="99.999.999-9"
                      value={this.state.rg}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>CNS</label>
                    <input
                      placeholder="CNS"
                      name="cns"
                      className="form-control"
                      value={this.state.cns}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Email</label>
                    <input
                      placeholder="EMAIL"
                      name="email"
                      className="form-control"
                      value={this.state.email}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Data Nascimento</label>
                    <InputMask
                      placeholder="DATA NASCIMENTO"
                      name="dataNascimento"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.dataNascimento}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Celular</label>
                    <InputMask
                      placeholder="TELEFONE CELULAR"
                      name="telefoneCelular"
                      className="form-control"
                      mask="(99) \99999-9999"
                      value={this.state.telefoneCelular}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Telefone Residencial</label>
                    <InputMask
                      placeholder="TELEFONE RESIDECIAL"
                      name="telefoneResidencial"
                      className="form-control"
                      mask="(99) 9999-9999"
                      value={this.state.telefoneResidencial}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Telefone Comercial</label>
                    <InputMask
                      placeholder="TELEFONE COMERCIAL"
                      name="telefoneComercial"
                      className="form-control"
                      mask="(99) 9999-9999"
                      value={this.state.telefoneComercial}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label>Nome Pai</label>
                    <input
                      placeholder="NOME PAI"
                      name="nomePai"
                      className="form-control"
                      value={this.state.nomePai}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label>Nome Mãe</label>
                    <input
                      placeholder="NOME MÃE"
                      name="nomeMae"
                      className="form-control"
                      value={this.state.nomeMae}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Estado Civil</label>
                    <select
                      name="estadoCivil"
                      className="form-control"
                      value={this.state.estadoCivil}
                      onChange={this.handleChange}
                    >
                      <option value={0}>NÃO INFORMADO</option>
                      <option value={1}>SOLTEIRO (A)</option>
                      <option value={2}>CASADO (A)</option>
                      <option value={3}>SEPARADO (A)</option>
                      <option value={4}>DIVORCIADO (A)</option>
                      <option value={5}>VIÚVO (A)</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Classificação</label>
                    <select
                      name="classificacao"
                      className="form-control"
                      value={this.state.classificacao}
                      onChange={this.handleChange}
                    >
                      <option value={0}>NENHUMA</option>
                      <option value={1}>GESTANTE</option>
                      <option value={2}>ESTIMULAÇÃO PRECOCE</option>
                      <option value={3}>CRIANÇA</option>
                      <option value={4}>HIPERTENSÃO</option>
                      <option value={5}>DIABETE</option>
                      <option value={6}>IDOSO</option>
                      <option value={7}>GINECOLOGIA</option>
                      <option value={8}>SAÚDE MENTAL</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label> </label>
                    <div className="form-check form-check-danger">
                      <label className="form-check-label">
                        <input
                          name="inativo"
                          type="checkbox"
                          className="form-check-input"
                          checked={this.state.inativo}
                          onChange={this.handleChecked}
                        />
                        Inativo
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label>Motivo Inativação</label>
                    <select
                      disabled={!this.state.inativo ? true : false}
                      name="tipoInativacao"
                      className="form-control"
                      value={this.state.tipoInativacao}
                      onChange={this.handleChange}
                    >
                      <option value={1}>NÃO INFORMADO</option>
                      <option value={2}>ALTA</option>
                      <option value={3}>DESLIGAMENTO</option>
                      <option value={4}>ENCAMINHAMENTO</option>
                      <option value={5}>OUTROS</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CadastroEndereco
          styleInativo={this.state.inativo ? styleInativo : null}
          value={this.state.endereco}
          onChange={this.handleChangeEndereco}
        />
        <CadastroObservacao
          styleInativo={this.state.inativo ? styleInativo : null}
          value={this.state.observacoes}
          onChange={this.handleChange}
        />
      </form>
    );
  }
}

export default CadastroPaciente;
